import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getCurrentUser',
      'isCurrentMachineAuthorized',
      'isCurrentMachineValidSubscription',
      'isCurrentMachineConnected'
    ])
  },
  methods: {
    isAvailable(item) {
      let allowed = true
      if (this.getCurrentUser.internal) return true //allow for internals
      if ('forInternals' in item && item.forInternals) return false //disallowed for non internals
      if ('forSupertechs' in item) allowed = item.forSupertechs ? this.getCurrentUser.expertLevel === 'supertech' : true
      if ('forKeyAccounts' in item && item.forKeyAccounts.length) allowed = allowed && item.forKeyAccounts.find(element => element.id === this.getCurrentUser.companyId)
      return allowed
    },
    isDisabled(item) {
      return item.disabled ||
        (!this.isCurrentMachineAuthorized && ['faultcodes'].filter(x => item.title.replace(' ', '').toLowerCase().startsWith(x)).length > 0) ||
        (!this.isCurrentMachineValidSubscription && ['faultcodes'].filter(x => item.title.replace(' ', '').toLowerCase().startsWith(x)).length > 0) ||
        (!this.isCurrentMachineConnected && ['locationhistory', 'faultcodes'].filter(x => item.title.replace(' ', '').toLowerCase().startsWith(x)).length > 0)
    }
  }
}
